import { render, staticRenderFns } from "./PlainRouterView.vue?vue&type=template&id=497ef9d3&scoped=true"
import script from "./PlainRouterView.vue?vue&type=script&lang=js"
export * from "./PlainRouterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ef9d3",
  null
  
)

export default component.exports